module.exports = __webpack_public_path__ + "static/img/item-2-3.bae1b58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-2-3.png
// module id = XghO
// module chunks = 2